/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-destructuring */
import React from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader, Input } from 'reactstrap';
import QuestionHeader from '../QuestionHeader';
import './styles.css';

// const alphabet = 'abcdefghijklmnopqrstuvwxyz';

// Kiểm tra đáp án đúng sai để xuất thông báo
function handleResult(question, answers) {
  let isCorrect = true;
  answers.forEach((element) => {
    if (!isCorrect) return;
    const correctAnswers = question.find((x) => x.id === element.id).answers;
    isCorrect = correctAnswers.some(x => x.trim().toLowerCase() === element.answer.trim().toLowerCase());
  });
  return isCorrect;
}

const FillWordInTheBlank = ({ data, onSubmit, userData, questionIndex = 0 }) => {
  const [state, setState] = React.useState({
    isSubmit: false,
    answers: [],
    userData: '',
  });

  const ref = React.useRef();
  ref.current = new Audio();
  const playAudio = React.useCallback((audioUrl) => {
    ref.current.src = audioUrl;
    ref.current.play();
  }, []);

  const onHandleInput = React.useCallback(
    (item, index) => {
      let answers = state.answers;
      const i = answers.findIndex((x) => x.id === index);
      if (item === '') {
        answers = answers.filter((x) => x.id !== index);
      } else if (i > -1) {
        answers[i].answer = item;
      } else {
        answers.push({ id: index, answer: item });
      }
      setState((prevState) => ({ ...prevState, answers }));
    },
    [state.answers],
  );

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, answers: userData ?? [] }));
  }, [userData]);

  const renderQuestion = React.useCallback(() => {
    return data.answers?.map((v, i) => (
      <div key={i} className='d-flex'>
        <div>
          {v.text
            ?.replace(v.answer, '#')
            .split(' ')
            .map((word, index) => {
              // Tách từ có dấu câu
              // let tempWord = word.match(/[^,.!?:;]+/)[0]
              // Từ được tách có giống đáp án?
              // word = (tempWord === v.answer ? word.replace(tempWord, '#') : word)
              return (
                <span key={index}>
                  <span style={{ display: 'inline-block' }}>
                    {word.includes('#') ? (
                      <span className='d-flex align-items-center'>
                        {word.split('').map((character, characterIndex) => {
                          const value = state.answers?.find((x) => x.id === i + 1);
                          const longestWord = v.answers.map(x => x.length);
                          return (
                            <span key={characterIndex}>
                              {character === '#' ? (
                                <Input
                                  value={value?.answer ?? ''}
                                  style={{ width: Math.max(...longestWord) * 24 }}
                                  className='input-fill-word-in-the-blank'
                                  onChange={(e) => {
                                    onHandleInput(e.target.value, v.id);
                                  }}
                                />
                              ) : (
                                character
                              )}
                            </span>
                          );
                        })}
                      </span>
                    ) : (
                      word
                    )}
                  </span>
                  <span>&nbsp;</span>
                </span>
              );
            })}
        </div>
      </div>
    ));
  }, [data.answers, onHandleInput, state.answers]);

  return (
    <Card>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='FillWordInTheBlank' />
      </CardHeader>
      <CardBody style={{ minHeight: 300 }}>
        {data.audioUrl && (
          <div className='mb-4'>
            <Button color='warning' onClick={() => playAudio(data.audioUrl)}>
              <i className='fas fa-play' />
              &nbsp;&nbsp;Click to listen
            </Button>
          </div>
        )}
        <div className='questionText'>{renderQuestion()}</div>
      </CardBody>
      <CardFooter>
        <Button
          color='primary'
          disabled={state.answers.length !== data.answers.length}
          onClick={() => {
            setState((prevState) => ({ ...prevState, isSubmit: true }));
            const result = handleResult(data.answers, state.answers);
            if (userData) {
              onSubmit({ id: data.id, isCorrect: result, answers: state.answers });
            }
            // if (result) {
            //   message.success('Kết quả: ' + result);
            // } else {
            //   message.warning('Kết quả: ' + result);
            // }
            // Callback
            // if (onSubmit && typeof onSubmit === 'function') onSubmit({ selectedAnswers: state.answers, result });
            if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers: state.answers, result });
          }}
        >
          Submit
          {' '}
          <i className='fas fa-arrow-right ml-3' />
        </Button>
      </CardFooter>
    </Card>
  );
};

export default FillWordInTheBlank;
